import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {AuthenticationAlertsService} from "../../services/authentication-alerts.service";
import {StateService} from "../../../commons/services/state.service";
import {SsoConfigModel} from "../../models/sso-config.model";
import {IamRequests} from "../../../iam/factories/iam-requests.service";
import {AUTH_ERROR_QUERY_PARAM} from "../../constants/sso.constants";

export class loginViewCtrl implements IController {

  private greetingTime: any;
  private imageGallery: any;
  private greeting: any;
  private image: any;
  private user: any;
  private loading: any;

  public ssoConfig: SsoConfigModel;
  public isLocalhost: boolean = false;
  public tenantId: string = '';

  /* @ngInject */
  constructor(private $log, private $auth, private $state, private $stateParams, private UserService, private commonsAlertsService: CommonsAlertsService,
              private authenticationAlertsService: AuthenticationAlertsService, private commonsDialogService: CommonsDialogService,
              private commonsConstants, private commonsService: CommonsService, private stateService: StateService, private IamRequests: IamRequests,
              private socialOauthRedirectService) {
  }

  $onInit() {
    this.isLocalhost = window.location.hostname === 'localhost';
    this.tenantId = localStorage.getItem('X-BRINGOZ-TENANT-ID') || '';

    this.greetingTime = this.commonsService.getGreetingTime();
    this.imageGallery = this.commonsConstants.loginImageGalleriesByDayTime[this.greetingTime];

    this.greeting = 'Good ' + this.greetingTime;
    this.image = this.imageGallery[Math.floor(Math.random() * this.imageGallery.length)];

    this.user = {
      email: '',
      password: ''
    };

    this.ssoConfig = this.IamRequests.getSsoConfig();

    if (this.$stateParams[AUTH_ERROR_QUERY_PARAM]) {
      this.authenticationAlertsService.loginError();
      this.$state.go('.', {[AUTH_ERROR_QUERY_PARAM]: null}, {location: 'replace', notify: false});
    }
  };

  loginClick(form) {

    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('access_token');

        this.loading = true;
        this.$auth.login(this.user)
          .then((response) => {
            this.onAfterLogin();
          })
          .catch((error) => {
            this.$log.error('Bringoz auth failed', error);

            if (error.status === 401) {
              error.data.code === 401001 ?
                this.authenticationAlertsService.loginErrorExcessiveFailedAttempts(error.data.more_info)
                  .then((res) => {
                    this._redirectOnLoginFail(res);
                  }) :

                this.authenticationAlertsService.loginError()
                  .then((res) => {
                    this._redirectOnLoginFail(res);
                  })

            } else {
              this.commonsAlertsService.somethingWentWrongError();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }

  authenticateClick(provider) {
    // Full-page redirect instead of satellizer's popup flow (see
    // SocialOauthRedirectService) - the popup's window.closed polling is unreliable
    // under browsers' Cross-Origin-Opener-Policy restrictions on the provider's login
    // page, same as the Auth0 SSO popup was.
    // Building the redirect URL is instant, but the browser still has to actually load
    // the provider's page - show the same loading state as password login so the click
    // doesn't look like it did nothing in the meantime.
    this.loading = true;
    this.socialOauthRedirectService.login(provider);
  }

  onAfterLogin() {
    const previousState = this.stateService.getPreviousState();
    if (!!previousState) {
      this.$state.go(previousState, {...this.stateService.getPreviousStateParams()});
    } else {
      this.$state.go('organizations.overview');
    }
  }

  saveTenantId() {
    if (this.tenantId) {
      localStorage.setItem('X-BRINGOZ-TENANT-ID', this.tenantId);
    } else {
      localStorage.removeItem('X-BRINGOZ-TENANT-ID');
    }
  }

  private _redirectOnLoginFail(res) {
    if (!!res) {
      this.$state.go('authentication.forgot', {user: this.user});
    }
  }


}

angular
  .module('bringoz.admin.authentication')
  .component('loginView', {
    bindings: {},
    template: require('./login-view.html').default,
    controller: loginViewCtrl
  });
